const cardItems = [
  {
    id: 1,
    title: '暴走黑料 · 年度最全艺人翻车实录',
    summary: '从年初到年中，暴走黑料持续追踪各路艺人的翻车名场面，本篇合集带你一文看尽年度精彩。',
    tag: '暴走黑料',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20amber%20composition%20with%20dramatic%20shadows%2C%20mysterious%20entertainment%20news%20atmosphere%2C%20flowing%20golden%20light%20forms%20against%20dark%20background%2C%20sophisticated%20editorial%20style%2C%20cinematic%20quality%20with%20high%20contrast%20warm%20lighting%2C%20elegant%20visual%20for%20media%20story%20feature%2C%20bold%20dramatic%20composition%20suggesting%20investigative%20content&width=700&height=440&seq=card-1-2026&orientation=landscape',
    reads: '3.2万',
  },
  {
    id: 2,
    title: '黑料社独家 · 顶流背后的商业帝国',
    summary: '黑料社深度起底某顶流艺人的商业版图，从代言矩阵到投资布局，数据详实令人震撼。',
    tag: '黑料社',
    date: '2026-07-27',
    image: 'https://readdy.ai/api/search-image?query=Deep%20crimson%20and%20golden%20abstract%20artistic%20scene%2C%20mysterious%20atmosphere%20with%20soft%20warm%20light%20beams%2C%20entertainment%20industry%20themed%20visual%20with%20dramatic%20composition%2C%20dark%20sophisticated%20background%2C%20editorial%20magazine%20quality%2C%20cinematic%20lighting%20with%20rich%20warm%20tones%2C%20bold%20visual%20suggesting%20exclusive%20celebrity%20content&width=700&height=440&seq=card-2-2026&orientation=landscape',
    reads: '2.8万',
  },
  {
    id: 3,
    title: '综艺翻车名场面 · 那些被剪掉的真实瞬间',
    summary: '综艺节目后期剪刀手究竟藏了多少猛料？多段被删减的争议画面首次整理曝光。',
    tag: '综艺深扒',
    date: '2026-07-26',
    image: 'https://readdy.ai/api/search-image?query=Golden%20spotlight%20on%20abstract%20dramatic%20stage%2C%20warm%20amber%20tones%20with%20deep%20shadows%2C%20mysterious%20entertainment%20atmosphere%2C%20artistic%20composition%20with%20flowing%20light%20particles%2C%20dark%20elegant%20background%2C%20sophisticated%20editorial%20style%2C%20cinematic%20quality%20visual%20for%20featured%20media%20content%2C%20bold%20and%20intriguing&width=700&height=440&seq=card-3-2026&orientation=landscape',
    reads: '2.5万',
  },
  {
    id: 4,
    title: '网红圈洗牌 · 上半年掉粉最惨的十位大V',
    summary: '从千万粉到门可罗雀，网红圈的残酷更迭远比想象中更快。数据对比触目惊心。',
    tag: '网红观察',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Warm%20coral%20and%20amber%20abstract%20composition%2C%20dramatic%20lighting%20effects%20on%20dark%20background%2C%20mysterious%20entertainment%20news%20visual%2C%20artistic%20flowing%20forms%20suggesting%20gossip%20and%20revelations%2C%20sophisticated%20editorial%20quality%2C%20cinematic%20high%20contrast%2C%20bold%20visual%20storytelling%20for%20media%20platform%20featured%20content&width=700&height=440&seq=card-4-2026&orientation=landscape',
    reads: '2.1万',
  },
  {
    id: 5,
    title: '品牌代言人风波 · 下半年最受争议的十个案例',
    summary: '品牌选代言人越来越像豪赌，盘点下半年争议最大的品牌代言事件与连锁反应。',
    tag: '深扒专题',
    date: '2026-07-24',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20golden%20light%20beams%20intersecting%20on%20dark%20stage%2C%20warm%20dramatic%20atmosphere%20for%20entertainment%20media%2C%20artistic%20composition%20with%20elegant%20flowing%20elements%2C%20mysterious%20and%20intriguing%20visual%20style%2C%20dark%20sophisticated%20background%2C%20editorial%20magazine%20quality%2C%20cinematic%20warm%20lighting%2C%20bold%20featured%20content%20presentation&width=700&height=440&seq=card-5-2026&orientation=landscape',
    reads: '1.9万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            精选深扒
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            暴走黑料与黑料社精选深度文章，不容错过的吃瓜干货
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cardItems.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/80 text-foreground-700 backdrop-blur-sm whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/40">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.reads} 阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}